import type { Brand } from '@fluenceur/types';
import api from '@/libs/axiosInstance';

export const fetchCurrentBrandDetails = async (): Promise<Brand> => {
  const response = await api.get('/dashboard/brands/me/details');
  return response.data;
};

export interface UpdateBrandDetailsDto {
  name: string;
  websiteUrl: string;
  city: string;
  addressLine1: string;
  addressLine2: string | null;
  postalCode: string;
  country: string;
  registrationNumber: string;
  vatNumber: string;
}

export const uploadBrandImage = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append('image', file);

  const response = await api.post(`/dashboard/brands/me/images`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data.imageUrl;
};

export const deleteBrandImage = async (): Promise<void> => {
  await api.delete('/dashboard/brands/me/images');
};
